import { BaseAddressSchema } from "@redotech/redo-return-core-common/address-collection";
import * as z from "zod";

export const validateInternationalAddresses = {
  name: "validateInternationalAddresses" as const,
  input: z.object({
    addresses: z.array(
      z.object({ id: z.string().optional(), address: BaseAddressSchema }),
    ),
  }),
  output: z.object({
    results: z.array(
      z.object({
        id: z.string().optional(),
        isInternational: z.boolean(),
        success: z.boolean(),
        avc: z.string().optional(),
        message: z.string().optional(),
        originalAddress: BaseAddressSchema,
        proposedAddress: BaseAddressSchema,
        changed: z.boolean(),
      }),
    ),
  }),
};
